/** State of a ПРРО in the ДПС register — see ai/docs/prro-api.md. */
export enum CashRegisterStateEnum {
  Active = "active",
  Suspended = "suspended",
  Closed = "closed",
}

/** A shift is open until its Z-report closes it. */
export enum ShiftStateEnum {
  Opened = "opened",
  Closed = "closed",
}
